import { env } from '@/lib/env';

/**
 * Stamp the transient enter-animation marker on a section frame's root tag
 * so the iframe can fade it in on mount. The iframe's inspector script
 * removes the attribute via rAF after the DOM insertion, which triggers the
 * CSS transition defined in `safetyStyles`.
 *
 * We only mark the first tag; downstream tags inside the frame are rendered
 * together with their ancestor and inherit the transition.
 */
export function markSectionEntering(html: string): string {
  if (!html) return html;
  return html.replace(/^(\s*)<([a-z][a-z0-9-]*)\b/i, '$1<$2 data-xavior-stream-enter');
}

export function resolveUrl(url: string): string {
  if (url.startsWith('http')) return url;
  return `${env.apiBaseUrl}${url}`;
}
